/**
 * Reveals a block as the reader scrolls to it.
 *
 * Progressive enhancement, deliberately one way: the markup renders visible, and the
 * hidden state is applied here, the moment an element starts being watched. Anything
 * that stops this script from running leaves the page whole rather than blank, which
 * is what keeps a crawler, a reader with JS off and a browser without
 * IntersectionObserver reading the same page.
 *
 * Opted into per element with data-reveal; the styles live beside the kit in
 * css/services-pages.css.
 */
(function () {
    'use strict';

    var blocks = document.querySelectorAll('[data-reveal]');

    if (!blocks.length || typeof IntersectionObserver === 'undefined') {
        return;
    }

    // Motion is the whole feature, so there is nothing to degrade to: leave every block
    // in its resting visible state and do not observe anything.
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    var pending = [];

    function reveal(el) {
        el.classList.add('is-revealed');
        observer.unobserve(el);

        var at = pending.indexOf(el);
        if (at !== -1) {
            pending.splice(at, 1);
        }
    }

    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                reveal(entry.target);
            }
        });
    }, {
        // Held back from the very edge so a block animates on its way in rather than
        // finishing before it has cleared the fold.
        rootMargin: '0px 0px -12% 0px',
        threshold: 0,
    });

    // The observer reports a crossing it saw, and it only samples once a frame. A jump
    // that clears a block in a single frame - dragging the scrollbar, a restored scroll
    // position on reload, a link to an anchor - never crosses the threshold while being
    // watched, and the block would stay at opacity 0 for good. So anything the scroll
    // has already carried above the fold is revealed outright, no animation owed.
    var sweeping = false;

    function sweep() {
        sweeping = false;

        pending.slice().forEach(function (el) {
            if (el.getBoundingClientRect().bottom < 0) {
                reveal(el);
            }
        });

        if (!pending.length) {
            window.removeEventListener('scroll', onScroll);
        }
    }

    function onScroll() {
        if (sweeping) {
            return;
        }

        sweeping = true;
        window.requestAnimationFrame(sweep);
    }

    blocks.forEach(function (block) {
        block.classList.add('is-armed');
        pending.push(block);
        observer.observe(block);
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    sweep();
})();
